import {
  AUTH_LOGOUT,
  AUTH_INPUT,
  SIGNUP_USERNAME_PASS,
  LOGIN_USERNAME_PASS,
  FACEBOOOK_AUTH,
  USER_DATA_FROM_FIRESTORE,
  FIREBASE_LOGIN,
  PASSWORD_RESET_EMAIL_SENT,
  CHANGE_LOGIN_EMAIL_SENT,
  UPDATE_USER_EMAIL,
  UPDATE_USERNAME,
  RESET_AUTH_FIELDS
} from '../constants/action-types';

const oldEmail = window.localStorage.getItem('emailForSignIn');
const InitialState = {
  isLoggedIn: false,
  userLoggedOut: false,
  userInfo: null,
  email: '',
  newEmail: '',
  oldEmail: oldEmail || '',
  password: '',
  newPassword: '',
  userName: '',
  userProfile: '',
  gotUserProfileFromFirestore: false,
  passwordResetEmailSent: false,
  passwordResetError: false,
  passwordResetPending: false,
  changeEmailVerificationEmailSent: false,
  changeEmailError: false,
  changeEmailVerificationRequestPending: false,
  updateEmailPending: false,
  updateEmailSuccess: false,
  updateEmailError: false,
  updateUsernameSuccess: null,
  updateUsernameError: null,
};

export default (state = InitialState, action) => {
  console.debug('Auth Reducer->', action.type, action);
  switch (action.type) {
    case LOGIN_USERNAME_PASS:
      return {
        ...state,
        isLoggedIn: action.isLoggedIn,
        success: action.success,
        error: action.error,
        userInfo: action.payload,
        email: '',
        password: '',
        userName: '',
        userLoggedOut: false,
      };
    case SIGNUP_USERNAME_PASS:
      return {
        ...state,
        isLoggedIn: action.isLoggedIn,
        success: action.success,
        error: action.error,
        userInfo: action.payload,
        email: '',
        password: '',
        userName: '',
        userLoggedOut: false,
      };
    case FACEBOOOK_AUTH:
      return {
        ...state,
        isLoggedIn: action.isLoggedIn,
        success: action.success,
        error: action.error,
        userInfo: action.payload,
        email: '',
        password: '',
        userName: '',
        userLoggedOut: false,
      };
    case FIREBASE_LOGIN:
      return {
        ...state,
        isLoggedIn: action.isLoggedIn,
        success: action.success,
        error: action.error,
        userInfo: action.payload,
        email: '',
        password: '',
        userName: '',
        userLoggedOut: false,
      };
    case USER_DATA_FROM_FIRESTORE:
      return { ...state, userProfile: action.payload, gotUserProfileFromFirestore: action.success };
    case AUTH_INPUT:
      return { ...state, [action.payload.target.name]: action.payload.target.value };
    case AUTH_LOGOUT:
      return { ...InitialState, userLoggedOut: true };
    case PASSWORD_RESET_EMAIL_SENT:
      return {
        ...state,
        passwordResetEmailSent: action.success,
        passwordResetError: action.error,
        passwordResetPending: action.pending,
      };
    case CHANGE_LOGIN_EMAIL_SENT:
      return {
        ...state,
        changeEmailVerificationEmailSent: action.success || false,
        changeEmailError: action.error || false,
        changeEmailVerificationRequestPending: action.pending,
      };
    case UPDATE_USER_EMAIL:
      return {
        ...state,
        updateEmailSuccess: action.success || false,
        updateEmailError: action.error || false,
        updateEmailPending: action.pending || false,
      };

    case UPDATE_USERNAME:
      return { ...state, updateUsernameSuccess: action.success, updateUsernameError: action.error };
    case RESET_AUTH_FIELDS:
      return { ...state, userName: '', email: '', password: '' }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/auth-reducer.js